import React from 'react';
import {smartJump} from 'utils/utils';
import {inject, observer} from 'mobx-react';
import {IMG_PATH} from '../../constant';
import Layout from '../Layout';

import './index.scss';

@inject('store')
@observer
class Hotspot extends React.Component {
    render() {
        const {jqwlbq: data = [], bg = {}} = this.props.store.renderData;
        const {jqwfMore = {}} = bg.data || {};
        if (!data.length) {
            return null;
        }
        return (
            <Layout
                id="jqwlbq"
                className="m-hotspot"
                titImg={`${IMG_PATH}/jqwl.png`}
                displayLimit={6}
                more={jqwfMore}
                moduleName="jqwlnr"
                tabData={data}
                eidSuffix="wanle"
                renderList={({list, tabName}) => {
                    return (
                        <div className="m-content">
                            {
                                list.map((v, k) => {
                                    const {img, name, jumpInfo = {}} = v;
                                    return <div className="m-content-item" data-sk-eid="list_wanle" data-sk-edata={JSON.stringify({tabName, url: jumpInfo})} key={k} onClick={() => {
                                        smartJump(jumpInfo.touchUrl);
                                    }}>
                                        <div className="img-wrapper">
                                            <img className="img" src={img} alt="" />
                                        </div>
                                        <div className="text">
                                            <div className="title">{name}</div>
                                        </div>
                                    </div>;
                                })
                            }
                        </div>
                    );
                }}
            />
        );
    }
}

export default Hotspot;